// Second-step sign-in helpers shared by the web AuthProvider and the mobile shell. The step-up token is never stored.
export const ENROLMENT_PENDING_MESSAGE = 'Your organisation requires two-factor sign-in. Setup is coming soon.';
export const THROTTLED_MESSAGE = 'Too many attempts. Wait a few minutes and try again.';
const WRONG_CODE = 'That code is not right';

export function classifyLoginResponse(data) {
  if (data && typeof data.token === 'string' && data.token) return { kind: 'session' };
  const mfaToken = data && typeof data.mfa_token === 'string' && data.mfa_token ? data.mfa_token : null;
  if (data?.mfa_required && mfaToken) return { kind: 'mfa', mfaToken };
  if (data?.mfa_enrolment_required && mfaToken) return { kind: 'enrol', mfaToken };
  throw new Error('Sign-in did not complete. Please try again.');
}

export async function verifySecondFactor(apiUrl, mfaToken, { code, recoveryCode }) {
  const body = recoveryCode ? { mfa_token: mfaToken, recovery_code: recoveryCode } : { mfa_token: mfaToken, code };
  let res;
  try {
    res = await fetch(`${apiUrl || ''}/api/auth/mfa/verify`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
  } catch {
    return { ok: false, reason: 'error', message: 'Could not reach the server. Check your connection and try again.' };
  }
  const data = await res.json().catch(() => ({}));
  if (res.ok) return { ok: true, data };
  const detail = typeof data?.detail === 'string' ? data.detail : '';
  if (res.status === 429) return { ok: false, reason: 'throttled', message: THROTTLED_MESSAGE };
  if (res.status === 401 && detail === WRONG_CODE) return { ok: false, reason: 'wrong', message: WRONG_CODE };
  if (res.status === 401) return { ok: false, reason: 'expired', message: detail || 'Verification expired; sign in again' };
  return { ok: false, reason: 'error', message: detail || 'Verification failed. Please try again.' };
}
